function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(252, 247, 241)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'noir': 'rgb(33, 33, 33)','zanzibar': 'rgb(104, 84, 60)','sauge': 'rgb(137, 156, 132)','pin': 'rgb(48, 81, 68)','nuit': 'rgb(57, 69, 99)','sunset': 'rgb(252, 93, 35)','camelia': 'rgb(214, 67, 106)','cactus': 'rgb(56, 164, 97)','croisiere': 'rgb(33, 33, 33)','iris': 'rgb(98, 50, 237)','terracotta': 'rgb(179, 88, 38)','kaki': 'rgb(97, 105, 91)','tango': 'rgb(212, 49, 49)','terra': 'rgb(121, 57, 57)','olive': 'rgb(97, 115, 95)','saint-emilion': 'rgb(93, 29, 52)','azure': 'rgb(54, 136, 214)','papaye': 'rgb(232, 97, 44)','riviera': 'rgb(99, 144, 202)','coquelicot': 'rgb(233, 60, 22)',};

    this.images = {'orage': 'url("//baiebrune.com/cdn/shop/files/Orage_68x.png?v=17730021565986926528")','damier': 'url("//baiebrune.com/cdn/shop/files/Damier_68x.png?v=2613534938915609694")','ecorce': 'url("//baiebrune.com/cdn/shop/files/Ecorce_68x.png?v=14019341425542939038")','ecru': 'url("//baiebrune.com/cdn/shop/files/Ecru_68x.png?v=9346086473081256062")','opium': 'url("//baiebrune.com/cdn/shop/files/Opium_68x.png?v=8063976743291373641")','minuit': 'url("//baiebrune.com/cdn/shop/files/Minuit_68x.png?v=17684462964065543527")','or-blanc': 'url("//baiebrune.com/cdn/shop/files/OrBlanc_Tissu_68x.png?v=9762357429770457191")','palme': 'url("//baiebrune.com/cdn/shop/files/Palme_68x.png?v=396314714754183186")','sauvage': 'url("//baiebrune.com/cdn/shop/files/Sauvage_68x.png?v=13252821821469227771")','dahlia': 'url("//baiebrune.com/cdn/shop/files/Dahlia_68x.png?v=17196703243861686043")','horizon': 'url("//baiebrune.com/cdn/shop/files/Horizon_68x.png?v=18337107152438249397")','pampa': 'url("//baiebrune.com/cdn/shop/files/Pampa_68x.jpg?v=1463408151707362569")','monaco': 'url("//baiebrune.com/cdn/shop/files/Monaco_68x.png?v=9329544735584299999")','lagon': 'url("//baiebrune.com/cdn/shop/files/Lagon_68x.png?v=7815703534130067176")','sunrise': 'url("//baiebrune.com/cdn/shop/files/Sunrise_68x.png?v=12488652868727515460")','lac': 'url("//baiebrune.com/cdn/shop/files/Lac_68x.png?v=2197132429495378982")','nomade': 'url("//baiebrune.com/cdn/shop/files/Nomade_68x.png?v=1981263001396891109")','desert': 'url("//baiebrune.com/cdn/shop/files/Desert_68x.png?v=11620348984153146540")','jean': 'url("//baiebrune.com/cdn/shop/files/Jean_68x.png?v=15799999550846795341")','varigotti': 'url("//baiebrune.com/cdn/shop/files/Varrigoti_Tissu_68x.png?v=5342825005002809309")','carrousel': 'url("//baiebrune.com/cdn/shop/files/Carrousel_tissu_68x.png?v=18386574592009527793")','azurite': 'url("//baiebrune.com/cdn/shop/files/Azurite_68x.png?v=3958826918637551872")','ballerine': 'url("//baiebrune.com/cdn/shop/files/Ballerine_68x.png?v=18379278711721046096")','coquillage': 'url("//baiebrune.com/cdn/shop/files/Coquillage_68x.png?v=187835108061074527")',};

    this.triggers = ['color','colour','couleur','farbe','cor',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

window.theme.swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  window.theme.swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);
